export default "__VITE_ASSET__DSGLt6$M__"